export const handlePrevious = ({ setCurrent, current }) => {
  setCurrent(current - 1);
};
